// import React from "react";
// import { useState, useEffect } from "react";
// import { Pagination } from "antd";
// import { RiDeleteBin6Line } from "react-icons/ri";
// import { axiosInstance } from "../../axiosInstance";
// import { ToastContainer, toast } from "react-toastify";

// export function Mywishlist() {
//   const [cartproducts, setcartProduct] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const[pageSize,setPageSize]=useState(3)

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//     LoadWishlist(page);
//   };
//   function LoadWishlist(currentPage) {
//     axiosInstance
//       .get(`/admin/getWishlist?pageIndex=${currentPage}&pageSize=${pageSize}`)
//       .then((response) => {
//         setcartProduct(response.data.data);
//         console.log("API Response:", response.data);

//       });
//   }
//   function handleDeleteClick(id) {
//     axiosInstance
//       .delete(`admin/deletewishlist/${id}`)
//       .then((response) => {
//         if (response.status === 200) {
//           toast.success(response.data.message || "Deleted Successfully");
//           LoadWishlist(currentPage);
//         } else {
//           toast.error("Something went wrong, please try again!");
//         }
//       })
//       .catch((error) => {
//         console.error("Delete failed:", error);
//         toast.error("Error deleting item. Please try again.");
//       });
//     console.log("ID", id);
//   }
//   useEffect(() => {
//     LoadWishlist(currentPage);
//   }, []);

//   return (
//     <>
//       <ToastContainer />
//       <div className="wishlist-container">
//         <div className="wishlist-maintitle">My Wishlist</div>
//         <div>
//           {cartproducts?.map((product) => (
//             <div className="wishlist-row">
//               <div className="wishlistImg">
//                 <img src={product.image ? product.image : "---"} />
//               </div>
//               <div>
//                 <div
//                   className={`product-stock ${
//                     product.availability === 1 ? "text-success" : "text-danger"
//                   }`}
//                 >
//                   {product.availability === 1 ? "In Stock" : "Out Of Stock"}
//                 </div>

//                 <div className="product-name">
//                   {product.product_name ? product.product_name : "---"}
//                 </div>
//                 <div className="product-subname">
//                   {product.saree_name ? product.saree_name : "---"}
//                 </div>
//                 <div className="product-details">
//                   Size: {product.size ? product.size : "---"}
//                 </div>
//               </div>
//               <div>
//                 <div className="product-prices">
//                   ₹ {product.price ? product.price : "---"}
//                 </div>
//                 <div>
//                   {product.availability === 1 ? (
//                     <button className="btnWishCart">Add To Cart</button>
//                   ) : (
//                     <button className="btnWishExplore">Explore Similar</button>
//                   )}
//                 </div>
//               </div>
//               <div
//                 style={{ color: "#8E8CB2" }}
//                 onClick={() => handleDeleteClick(product.id)}
//               >
//                 <RiDeleteBin6Line />
//               </div>
//             </div>
//           ))}
//         </div>

//         <Pagination
//           className="custom-pagination"
//           current={currentPage}
//           pageSize={pageSize}
//           onChange={handlePageChange} // Update displayed products
//           showSizeChanger={false} // Disable page size changes
//         />
//       </div>
//     </>
//   );
// }
import { useEffect, useState } from "react";
import axios from "axios";
import { Pagination } from "antd";
import { RiDeleteBin6Line } from "react-icons/ri";
import { axiosInstance } from "../../axiosInstance";
import { toast, ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

export function Mywishlist() {
  const [cartproducts, setCartProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(2); // Fixed page size
  const [totalItems, setTotalItems] = useState(0);

  const fetchWishlist = async (currentPage) => {
    try {
      const response = await axiosInstance.get(
        `/admin/getWishlist?pageIndex=${currentPage}&pageSize=${pageSize}`
      );
      const responseData = response.data.data;

      // Separate out product items (those with w_id)
      const products = responseData.filter((item) => item.w_id);

      setCartProducts(products);
      setTotalItems(responseData[0]?.count || 0);
      console.log("totalItems", totalItems);
    } catch (error) {
      console.log(error);
    }
  };
  
  useEffect(() => {
    fetchWishlist(currentPage);
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  async function handleDeleteClick(productwid) {
    try {
      const { data } = await axiosInstance.delete(
        `/admin/deletewishlist/${productwid}`
      );
      if (data.status === 200) {
        toast.success(data.message || "Deleted Successfully");
        fetchWishlist(currentPage);
      } else {
        toast.error("Something went wrong, please try again!");
      }
    } catch (error) {
      console.error("Delete failed", error);
    }
  }

  return (
    <>
      <ToastContainer />
      <div className="wishlist-container">
        <div className="wishlist-maintitle">My Wishlist</div>
        <div>
          {cartproducts?.map((product) => (
            <div className="wishlist-row" key={product.id}>
              <div className="wishlistImg">
                <img src={product.image || "---"} alt="Product" />
              </div>
              <div>
                <div
                  className={`product-stock ${
                    product.availability === 1 ? "text-success" : "text-danger"
                  }`}
                >
                  {product.availability === 1 ? "In Stock" : "Out Of Stock"}
                </div>
                <div className="product_name">
                  {product.product_name || "---"}
                </div>
                <div className="product-subname">
                  {product.saree_name || "---"}
                </div>
                <div className="product-details">
                  Size: {product.size || "---"}
                </div>
              </div>
              <div>
                <div className="product-prices">₹ {product.price || "---"}</div>
                <div>
                  {product.availability === 1 ? (
                    <button className="btnWishCart">Add To Cart</button>
                  ) : (
                    <Link to="/">
                      <button className="btnWishExplore">
                        Explore Similar
                      </button>
                    </Link>
                  )}
                </div>
              </div>
              <div
                style={{ color: "#8E8CB2", cursor: "pointer" }}
                onClick={() => handleDeleteClick(product.w_id)}
              >
                <RiDeleteBin6Line />
              </div>
            </div>
          ))}
        </div>

        <Pagination
          className="custom-pagination"
          current={currentPage}
          pageSize={pageSize}
          total={totalItems}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>
    </>
  );
}
